export const GetTableHeight = (tabSelector) => {
    let table = document.querySelector(tabSelector);
    let top = table.getBoundingClientRect().top;
    return (window.innerHeight - top - 80);
}